export const MAIN_CONTENT_ID = "main-content";

export const SkipLink = () => (
  <a
    href={`#${MAIN_CONTENT_ID}`}
    onClick={(event) => {
      event.preventDefault();
      document.getElementById(MAIN_CONTENT_ID)?.focus();
    }}
    className="sr-only rounded-md bg-surface-overlay px-3 py-2 text-sm font-medium text-ink shadow-overlay outline-hidden focus-visible:not-sr-only focus-visible:fixed focus-visible:top-2 focus-visible:left-2 focus-visible:z-50 focus-visible:ring-2 focus-visible:ring-focus"
  >
    Skip to content
  </a>
);
